export class DistribucionDeFondosRequest {
  numeroCuenta: string;
  transferencias: {
    numeroCuenta: string;
    monto: number;
  }[];

  constructor(
    numeroCuenta: string,
    transferencias: {
      numeroCuenta: string;
      monto: number;
    }[],
  ) {
    this.transferencias = transferencias.filter((t) => t.monto > 0);
    this.numeroCuenta = numeroCuenta;
  }
}
